module.exports = "pegasus_template/assets/theme2/twitter-icon.png";